var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBiciElectricaGris(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 67,
    viewBox: "0 0 65 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9220",
    "data-name": "Group 9220",
    transform: "translate(587 -343)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13487",
    "data-name": "Rectangle 13487",
    width: 65,
    height: 67,
    rx: 32.5,
    transform: "translate(-587 343)",
    fill: "#e1eaec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bicicleta-electrica",
    d: "M30.857,21.963V15.176a4.341,4.341,0,0,0-4.336-4.336H25.076V13.73h1.445a1.447,1.447,0,0,1,1.445,1.445V16.26H26.594a6.647,6.647,0,0,0-5.654,3.121l-3.993,6.342L11.51,17.344h2.22V14.453h-6v2.379l2.213,3.41-.751,1.752a7.589,7.589,0,1,0,5.878,8.663A6.642,6.642,0,0,0,19.1,27.736l4.291-6.815a3.77,3.77,0,0,1,3.208-1.771h1.373v2.812a7.588,7.588,0,1,0,2.891,0ZM14.8,27.718a3.805,3.805,0,0,1-1.354.249H9.78l2.059-4.805ZM7.588,34.109a4.7,4.7,0,0,1,0-9.395c.145,0,.289.008.432.021L6.26,28.842a1.445,1.445,0,0,0,1.328,2.016h4.469a4.706,4.706,0,0,1-4.469,3.252Zm21.824,0a4.7,4.7,0,0,1-1.445-9.166v4.469a1.445,1.445,0,0,0,2.891,0V24.943a4.7,4.7,0,0,1-1.445,9.166ZM19.27,9.178H13.514L17.271,0H20.43L17.824,6.287h5.922l-3.873,8.166L17.344,15.9V13.152Zm0,0",
    transform: "translate(-573 354)",
    fill: "#0b71c3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiciElectricaGris);
export default __webpack_public_path__ + "static/media/BiciElectricaGris.322518b8fc50d0bed5805a03c021b610.svg";
export { ForwardRef as ReactComponent };